import * as React from "react";

import Header from "components/header";
import { HeaderInMainPackage } from "components/header-in-main";
import { DashboardPackage } from "components/dashboard";
import { FilterTitlesModal } from "components/modal";

import "./Package.scss";
import { closeModal, openModal } from "core/state/modal/actions";
import { connect } from "react-redux";
import { getActiveModalName } from "core/state/modal/selectors";
import { StoreShape } from "core/reducers";
import {
  loadWebsiteLinks,
  loadWebsites,
  loadWebsiteTypes
} from "core/state/websites/actions";
import { fetchCountries } from "core/state/meta/actions";
import { getTitlesSelected } from "core/state/meta/selectors";
import { loadTitles } from "core/state/titles/actions";
import { withPackageDataLoader } from "components/dataHOC/mountLoaders";
import { countTrue } from "common/utils";

const MODAL_NAME = "FilterTitlesModal";

const Page: React.SFC<{
  activeModal: string;
  projectId: string;
  openFilterModal: () => void;
  closeFilterModal: () => void;
  titlesSelected: number;
}> = ({
  projectId,
  activeModal,
  openFilterModal,
  closeFilterModal,
  titlesSelected
}) => (
  <div className="page">
    <Header className="page__header" />
    <main className="page__main">
      <HeaderInMainPackage
        className="page__navigation"
        titlePage="Digital project"
        captionSelected={`${titlesSelected} Titles selected`}
        onCaptionSelectedClick={openFilterModal}
        projectId={projectId}
      />
      <DashboardPackage className="page__dashboard" projectId={projectId} />
    </main>
    <FilterTitlesModal
      className="page__modal"
      visible={activeModal === MODAL_NAME}
      onClose={closeFilterModal}
    />
  </div>
);

const mapStateToProp = (
  state: StoreShape,
  { projectId }: { projectId: string }
) => ({
  activeModal: getActiveModalName(state),
  titlesSelected: countTrue(getTitlesSelected(state, projectId))
});

const mapDispatchToState = (dispatch: any) => ({
  openFilterModal: () => dispatch(openModal(MODAL_NAME)),
  closeFilterModal: () => dispatch(closeModal(MODAL_NAME))
});

export default withPackageDataLoader({
  page: [fetchCountries],
  hook: [loadTitles, loadWebsites, loadWebsiteTypes, loadWebsiteLinks]
})(connect(mapStateToProp, mapDispatchToState)(Page));
